import axios from "@shared/axios";
import MovementCategory from "@shared-models/movement/movement.category.model";
import GuideMovementRootInterface from "@shared-interfaces/movement/guide.movement.root.interface";
import SubCategoriesByRootResponseInterface from "@shared-interfaces/workout/sub.categories.by.root.response.interface";
import MovementsBySubCategoryResponseInterface from "@shared-interfaces/movement/movements.by.sub.category.response.interface";
import MovementResponseInterface from "@shared-interfaces/movement/movement.response.interface";

async function getRootCategories(): Promise<MovementCategory[]>
{
	const response = await axios.get("/movements");
	return response?.data ?? [];
}

async function getMovementsTree(): Promise<GuideMovementRootInterface[]>
{
	const response = await axios.get("/movements-tree");
	return response?.data ?? [];
}

async function getSubCategoriesByRoot(rootAlias: string): Promise<SubCategoriesByRootResponseInterface | null>
{
	const response = await axios.get(`/movements/${ rootAlias }`);
	return response?.data ?? null;
}

async function getMovementsBySubCategory(rootAlias: string, subAlias: string): Promise<MovementsBySubCategoryResponseInterface | null>
{
	const response = await axios.get(`/movements/${ rootAlias }/${ subAlias }`);
	return response?.data ?? null;
}

async function getMovement(rootAlias: string, subAlias: string, movementAlias: string): Promise<MovementResponseInterface | null>
{
	const response = await axios.get(`/movements/${ rootAlias }/${ subAlias }/${ movementAlias }`);
	return response?.data ?? null;
}

/** Réponse minimale pour les vignettes "Mouvements comme..." des pages workout-type :
 *  juste de quoi rendre la cover + naviguer vers /movements/{root}/{cat}/{alias}. */
interface MovementByAliasInterface
{
	alias: string;
	label: string | null;
	labelEn: string | null;
	coverImage: string | null;
	categoryAlias: string | null;
	rootAlias: string | null;
}

async function getMovementsByAliases(aliases: string[]): Promise<MovementByAliasInterface[]>
{
	if (aliases.length === 0) return [];
	const response = await axios.get("/movements/by-aliases", {
		params: { aliases: aliases.join(",") },
	});
	return response?.data ?? [];
}

export {
	getRootCategories,
	getMovementsTree,
	getSubCategoriesByRoot,
	getMovementsBySubCategory,
	getMovement,
	getMovementsByAliases,
};
export type { MovementByAliasInterface };
